import { styled } from '@mui/material';

export const SessionReplayPlayControls = styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: theme.spacing(2),
}));

export const SessionReplayHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(1),
}));

export const SessionReplayPhaseLabel = styled('div')(({ theme }) => ({
    fontWeight: 'bold',
    color: '#666666',

    '> span': {
        fontWeight: 'normal',
        color: theme.palette.primary.main,
    },
}));

export const SessionReplayCurrentFrame = styled('div')(({ theme }) => ({
    color: '#666666',
}));

export const SessionReplayAndResultsTabsWrapper = styled('div')(({ theme }) => ({
    minHeight: 640,
}));

export const SessionReplayInnerCanvasWrapper = styled('div')<{ $displayWidth: number; $aspectRatio: string }>(
    ({ theme, $displayWidth, $aspectRatio }) => ({
        width: $displayWidth,
        maxWidth: '100%',
        aspectRatio: $aspectRatio,
        position: 'relative',
        border: '1px solid rgb(102, 102, 102)',
        borderRadius: theme.shape.borderRadius * 2,
    }),
);
